// extracted by mini-css-extract-plugin
export default {"title":"W5nJY0","subtitle":"pJ2SjB","progressBarWrapper":"xZKPpV","textSecondary":"PpwY18","desktopText":"ofcDVB"};